import { render, staticRenderFns } from "./ArticleModal.vue?vue&type=template&id=7b802608&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.5.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b802608",
  null
  
)

export default component.exports